import React from "react";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import { useTranslation } from "react-i18next";
import { BusinessAreaService } from "../../../services/BusinessAreaService";

export default function BusinessAreaDelete({ businessArea, onClose, isOpen }) {
  let { t } = useTranslation();
  function deleteBusinessArea() {
    BusinessAreaService.delete(businessArea.id).then((data) => {
      onClose();
    });
  }
  return (
    <ModalContainer
      modalTitle={t("Delete  Business Area")}
      onClose={onClose}
      submitButtonAction={deleteBusinessArea}
      submitButtonTitle={t("Delete")}
      cancelButtonTitle={t("Cancel")}
      cancelButtonAction={onClose}
      submitButtonType="button"
      isOpen={isOpen}
    >
      <div className="form-group text-center">
        <label className="label"> {businessArea?.description}</label>
        <br />
        <label className="label">
          {t("Are you sure you want to delete ?")}
        </label>
      </div>
    </ModalContainer>
  );
}
